import { Expose, Type } from "class-transformer";

import { LifeInfo } from "src/shared/models/life-info.model";
import { PgaPolicyDetail } from "src/shared/models/policy-detail.model";

export class LifePolicyDetail extends PgaPolicyDetail {
    @Expose()
    @Type(() => LifeInfo)
    lifeInfo?: LifeInfo;
}
